import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SEND_STATUS, MESSAGE_TYPES, IMAGE_DISPLAY, IMAGE_ASPECT_RATIO } from '../constants/message';
import { COMPLEX_IMAGE } from '../constants/dimensions';
import Image from './Image';

export default class ImageMessage extends Component {
    static propTypes = {
        accentColor: PropTypes.string,
        imageAspectRatio: PropTypes.string,
        mediaSize: PropTypes.number,
        mediaUrl: PropTypes.string.isRequired,
        onError: PropTypes.func,
        onLoad: PropTypes.func,
        sendStatus: PropTypes.string,
        type: PropTypes.string.isRequired,
    };

    state = {
        mediaUrl: this.props.mediaUrl,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.mediaUrl !== nextProps.mediaUrl) {
            // keep the old url so we can display it while the new one loads from
            // the CDN.
            return {
                mediaUrl: nextProps.mediaUrl,
                oldMediaUrl: prevState.mediaUrl,
            };
        }

        return null;
    }

    onLoad = (e) => {
        const width = e.target.width;
        const height = e.target.height;

        const { imageAspectRatio, onLoad } = this.props;
        const displayedAspectRatio =
            imageAspectRatio === IMAGE_ASPECT_RATIO.SQUARE
                ? COMPLEX_IMAGE.SQUARE.ASPECT_RATIO
                : COMPLEX_IMAGE.ASPECT_RATIO;

        if (width / height > displayedAspectRatio) {
            this.setState({
                imageDisplay: IMAGE_DISPLAY.WIDE,
            });
        } else {
            this.setState({
                imageDisplay: IMAGE_DISPLAY.TALL,
            });
        }

        if (onLoad) {
            onLoad(e);
        }
    };

    render() {
        const { oldMediaUrl, imageDisplay } = this.state;
        const { type, sendStatus, mediaSize, mediaUrl, onError, accentColor } = this.props;

        const onClickUrl = type === MESSAGE_TYPES.IMAGE && sendStatus === SEND_STATUS.SENT ? mediaUrl : null;

        return (
            <Image
                accentColor={accentColor}
                preloaderImageUrl={oldMediaUrl}
                imageUrl={mediaUrl}
                mediaSize={mediaSize}
                onError={onError}
                onLoad={this.onLoad}
                loaderClassName={imageDisplay}
                forceShowLoader={sendStatus === SEND_STATUS.SENDING}
                onClickUrl={onClickUrl}
                type={type}
            />
        );
    }
}
